import { Component } from '@angular/core';

@Component({
    selector: 'ct-errors',
    templateUrl: 'errors.component.html',
    standalone: false
})

export class ErrorsComponent {
}
